<template>
  <!-- Figma D6 "Add Service. Items": same component cards as the diagnosis items, with edit / remove in the strip -->
  <main class="addedServicesPg flex flex-col gap-[20px]">
    <EvalComponentCard v-for="(item, index) in services" :id="'service-' + index" :key="index" :title="item.option"
      :value="item.value">
      <template #actions>
        <span class="flex items-center gap-[8px] flex-shrink-0">
          <button type="button" class="p-0 leading-none w-[24px] h-[24px] rounded-full transition-all duration-300 flex items-center justify-center border-0
              text-[#7695ff] !bg-[#fff] hover:text-[#fff] hover:!bg-[#7695ff]" aria-label="Delete note"
            @click="$emit('edit', index)">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" class="w-[14px] h-[14px]" viewBox="0 0 24 24">
              <path d="M0 0h24v24H0z" fill="none" />
              <path fill="currentColor"
                d="M3.995 17.207V19.5a.5.5 0 0 0 .5.5h2.298a.5.5 0 0 0 .353-.146l9.448-9.448l-3-3l-9.452 9.448a.5.5 0 0 0-.147.353m10.837-11.04l3 3l1.46-1.46a1 1 0 0 0 0-1.414l-1.585-1.586a1 1 0 0 0-1.414 0z" />
            </svg>

          </button>
          <button type="button" class="p-0 leading-none w-[24px] h-[24px] rounded-full transition-all duration-300 flex items-center justify-center border-0
              text-[#F67280] !bg-[#fff] hover:text-[#fff] hover:!bg-[#F67280]" aria-label="Delete note"
            @click="$emit('remove', index)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
              class="w-[14px] h-[14px]">
              <path d="M0 0h24v24H0z" fill="none" />
              <path fill="currentColor" fill-rule="evenodd"
                d="M9.774 5L3.758 3.94l.174-.986a.5.5 0 0 1 .58-.405L18.411 5h.088h-.087l1.855.327a.5.5 0 0 1 .406.58l-.174.984l-2.09-.368l-.8 13.594A2 2 0 0 1 15.615 22H8.386a2 2 0 0 1-1.997-1.883L5.59 6.5h12.69zH5.5zM9 9l.5 9H11l-.4-9zm4.5 0l-.5 9h1.5l.5-9zm-2.646-7.871l3.94.694a.5.5 0 0 1 .405.58l-.174.984l-4.924-.868l.174-.985a.5.5 0 0 1 .58-.405z" />
            </svg>
          </button>
        </span>
      </template>
      <EvalServiceRow :item="item" :actions="getBookingActions(item.value)" @service-change="onChange(item)"
        @warranty-change="warrantyChanged(item)" @select-part="$emit('select-part', item, index)" />
      <!-- labor fee -->
      <div
        class="flex items-center justify-between mt-[12px] px-[12px] h-[36px] rounded-[8px] bg-white border-1 border-[#EFEFEF] font-roboto text-[14px]">
        <span class="text-[#666666]">Labor Fee</span>
        <span class="font-medium text-[#333333]">
          {{ item.is_service_warranty ? "Labor Warranty" : "$" + $helper.formatAmount(item.diagnosis_labor_price ?? 0)
          }}
        </span>
      </div>
      <nest_selected_part :item="item" />
    </EvalComponentCard>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import nest_selected_part from "./nest_selected_part.vue";
import EvalComponentCard from "./EvalComponentCard.vue";
import EvalServiceRow from "./EvalServiceRow.vue";

export default {
  components: {
    nest_selected_part,
    EvalComponentCard,
    EvalServiceRow,
  },

  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["edit", "remove", "select-part"],

  computed: {
    ...mapGetters(["bookingServices"]),
  },

  methods: {
    getBookingActions(value) {
      const actions = this.bookingServices?.actions;
      if (!actions) {
        return [];
      }
      return (value == 3 ? actions.required : actions.recommended) ?? [];
    },

    onChange(item) {
      item.booking_action_id = item.selected_service.id;
      if (!item.is_service_warranty) {
        item.diagnosis_labor_price = item.selected_service.price ?? item.diagnosis_labor_price;
      }
      item.is_error = false;
      item.error = "";
    },

    warrantyChanged(item) {
      // No labor price when the labor is under warranty
      if (item.is_service_warranty) {
        delete item.diagnosis_labor_price;
      } else {
        item.diagnosis_labor_price = item.selected_service?.price ?? 0;
      }
    },
  },
};
</script>
